class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.fetchCartDetails()
    this.openCartNotification()
  }

  currencyFormatter(price){
    const formatter = new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 2
    });
    return formatter.format(price)
  }

  fetchCartDetails(open = false){
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    fetch(`${routes.cart_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        alet(response.message)
        return;
      } else if (this.notification){
        if(response.item_count > 0){
          let html = '<div id="shopify-section-cart-notification-product" class="shopify-section">'
          response.items.forEach(v => {
            html += `
            <div id="cart-notification-product-${v.key}" class="cart-item">
              <div class="cart-notification-product__image global-media-settings">
                <img src="${v.image}" alt="" width="70" height="70" loading="lazy">
              </div>
              <div>
                <h3 class="cart-notification-product__name h4">${v.product_title}</h3>
                <div class="product-option">Price: ${this.currencyFormatter(v.price / 100)} x ${v.quantity}</div>
                <div class="product-option">Total: ${this.currencyFormatter(v.line_price / 100)}</div>
                <dl></dl>
              </div>
            </div>`
          })
          html += '</div>'
          document.getElementById('cart-notification-product').innerHTML = html
          // console.log(document.querySelector('#cart-icon-bubble .cart-count-bubble > span[aria-hidden="true"]'))
          // document.querySelector('#cart-icon-bubble .cart-count-bubble > span[aria-hidden="true"]').innerHTML = response.item_count
          // document.querySelector('#cart-icon-bubble .cart-count-bubble > span.visually-hidden').innerHTML = `${response.item_count} items`
          if(open){
            this.open()
          }
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (this.notification && this.notification.classList.contains('is-empty')) this.notification.classList.remove('is-empty');
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }
  openCartNotification(){
    let $this = this
    document.querySelector('.header__icon--cart').addEventListener('mouseover',function(event){
      console.log('mouseover')
      console.log(event)
      console.log('$this',$this)
      $this.open()
    })
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log('parsedState')
    console.log(parsedState)
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if(section.id == 'cart-notification-product'){
        this.fetchCartDetails()
      }else{
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          // section.selector
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        // selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
